import { LocalizedText } from 'src/types/common/localized'
import { TLang } from 'src/constants/langs'

import { TextContentRo } from './ro/TextContentRo'
import { TextContentDe } from './de/TextContentDe'
import { TextContentEs } from './es/TextContentEs'
import { TextContentEn } from './en/TextContentEn'
import { TextContentFr } from './fr/TextContentFr'
import { TextContentIt } from './it/TextContentIt'
import { TextContentPt } from './pt/TextContentPt'
import { TextContentEl } from './el/TextContentEl'
import { TextContentSl } from './sl/TextContentSl'

export const texts: Record<TLang, LocalizedText> = {
    en: { content: <TextContentEn /> },
    de: { content: <TextContentDe /> },
    ro: { content: <TextContentRo /> },
    es: { content: <TextContentEs /> },
    fr: { content: <TextContentFr /> },
    it: { content: <TextContentIt /> },
    pt: { content: <TextContentPt /> },
    el: { content: <TextContentEl /> },
    sl: { content: <TextContentSl /> },
}
